import styled, { css } from 'styled-components';

const fullWidthStyles = css`
  .crossfade-image {
    width: 100%;
    height: 100%;
    position: absolute !important;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
      position: absolute !important;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }
`;

const constrainedWidthStyles = css`
  max-width: 1196px;
  margin: 0 auto;
  right: 0;

  .section-container-row {
    padding: 225px 28px 190px 28px !important;
  }
  .crossfade-image {
    width: 100%;
    height: 100%;
    max-width: 1224px !important;
    margin: 0 auto;
    position: relative;
    img {
      width: 510px !important;
      height: 100%;
      position: absolute !important;
      top: 0;
      right: 0;
      object-fit: contain;
      object-position: bottom;
    }
  }
  @media (max-width: 992px) {
    .crossfade-image {
      img {
        width: 390px !important;
      }
    }
  }
  @media (max-width: 1276px) {
    .section-container-row {
      padding: 190px 28px 140px 28px !important;
    }
    .crossfade-image {
      img {
        width: 480px !important;
        right: 28px;
      }
    }
  }
  @media (max-width: 991px) {
    .crossfade-image {
      img {
        width: 375px !important;
      }
    }
  }
  @media (max-width: 1120px) {
    .content {
      width: calc(100% * 6 / var(--Grid-columns));
    }
  }
  @media (max-width: 767px) {
    margin-top: 0 !important;
    height: 600px !important;

    .bottom-gradient {
      bottom: -40px;
      height: 260px;
    }
    .crossfade-image {
      top: 100px;

      img {
        width: auto !important;
        height: 100% !important;
        margin: 0 auto;
        right: 0;
        left: 0;
      }
    }
    .content {
      width: 100%;
    }
  }
  @media (max-width: 575px) {
    height: 485px !important;

    .bottom-gradient {
      bottom: 0;
    }
    .crossfade-image {
      top: 75px;

      img {
        width: calc(100% - 56px) !important;
        height: auto !important;
        bottom: 0;
        top: auto;
        position: absolute !important;
      }
    }
  }
`;

const StyledCarouselBackground = styled.div`
  ${({ $width }) => ($width === 'constrained' ? constrainedWidthStyles : fullWidthStyles)}
  ${({ $desktopBackground }) =>
    $desktopBackground?.includes('image')
      ? `background: url(${$desktopBackground});`
      : `background: ${$desktopBackground};`}
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-size: cover;
  background-position: center;

  @media (max-width: 767px) {
    ${({ $mobileBackground }) =>
      $mobileBackground?.includes('image')
        ? `background: url(${$mobileBackground});`
        : `background: ${$mobileBackground};`}
  }

  @media (min-width: 575px) and (max-width: 767px) {
    background-position: 0 -175px;

    img {
      object-position: 0 -175px;
    }
  }
`;

const BottomGradient = styled.div`
  ${({ styles }) => `
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100px;
    background: ${styles};
    @media (max-width: 575px) {
      height: 260px;
    }`}
`;

export { BottomGradient, StyledCarouselBackground };
